import React from "react";
import { useTranslation } from "react-i18next";
import { Phone, MapPin, Mail } from "lucide-react";
import { WELWORTH_LOGO, COMPANY_INFO } from "@/lib/brand";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-navy-deep text-parchment/80 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-14 h-14 bg-white rounded-sm overflow-hidden flex items-center justify-center">
              <img src={WELWORTH_LOGO} alt="Welworth Creative Media" className="max-h-full max-w-full object-contain p-1" />
            </div>
            <div>
              <div className="font-display text-2xl text-parchment">{t("meta.brand")}</div>
              <div className="text-[10px] tracking-overline uppercase text-gold font-bold">{t("meta.brand_tagline")}</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed">{t("about.hero_body")}</p>
        </div>
        <div>
          <div className="text-[10px] tracking-overline uppercase text-gold mb-3 font-bold">{t("nav.book")}</div>
          <ul className="space-y-2 text-sm">
            <li>{t("home.cta_primary")}</li>
            <li>{t("home.step1_title")}</li>
            <li>{t("home.step2_title")}</li>
            <li>{t("home.step3_title")}</li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-overline uppercase text-gold mb-3 font-bold">{t("footer.contact_overline")}</div>
          <ul className="space-y-2 text-sm" data-testid="footer-contacts">
            {COMPANY_INFO.phones.map((p) => (
              <li key={p} className="flex items-center gap-2"><Phone size={14}/> <a href={`tel:${p.replace(/\s+/g,"")}`} className="hover:text-gold">{p}</a></li>
            ))}
            <li className="flex items-center gap-2"><Mail size={14}/> <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-gold">{COMPANY_INFO.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 shrink-0"/> <span>{COMPANY_INFO.address}</span></li>
            <li className="pt-1" data-testid="footer-cities">
              <div className="text-[10px] tracking-overline uppercase text-gold font-bold">{t("footer.cities_overline")}</div>
              <div className="text-sm mt-1">{COMPANY_INFO.cities.join(" · ")}</div>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-overline uppercase text-gold mb-3 font-bold">{t("about.promise_overline")}</div>
          <p className="text-sm leading-relaxed">{t("about.promise_title")}</p>
        </div>
      </div>
      <div className="border-t border-parchment/10 py-5 text-center text-xs text-parchment/50">
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </div>
    </footer>
  );
}
